:host {
  display: block;
  --spw-input-height: 40px;
  --spw-input-padding: 0 12px;
  --spw-input-text-align: left;
  --spw-input-font-size: 16px;
  --spw-input-border: var(--spw-color-themes-grey-grey-800);
}

.spw-text-field {
  position: relative;
  &__input-container {
    flex: 1;
    position: relative;
    display: flex;
  }
  &__input {
    flex: 1;
    width: 100%;
    height: var(--spw-input-height);
    padding: var(--spw-input-padding);
    text-overflow: ellipsis;
    line-height: var(--spw-input-height);
    border-radius: 4px;
    font-size: var(--spw-input-font-size);
    text-align: var(--spw-input-text-align);
    border: 1px solid var(--spw-input-border);
    &:hover {
      outline: 4px solid var(--spw-color-themes-grey-grey-300);
    }
    &:focus,
    &:focus-visible {
      outline: 3px solid var(--spw-ds-focus);
      outline-offset: 2px;
    }
    &[type='number'] {
      -moz-appearance: textfield;
      -webkit-appearance: none;
      appearance: none;
      margin: 0;
      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      &[type='number'] {
        -moz-appearance: textfield;
      }
    }
    :host-context(spw-header) & {
      border: 1px solid var(--spw-color-themes-grey-grey-300);
    }
    .spw-text-field--disabled & {
      border-color: var(--spw-color-themes-grey-grey-400);
      background: var(--spw-color-themes-grey-grey-100);
      color: var(--spw-color-themes-grey-grey-500);
      cursor: not-allowed;
      &::placeholder {
        color: var(--spw-color-themes-grey-grey-500);
      }
      &:hover,
      &:focus,
      &:focus-visible {
        outline: none;
      }
    }
    .spw-text-field--is-error & {
      border-color: var(--spw-colors-states-error-error-300);
    }
    .spw-text-field--large & {
      height: 60px;
      padding: 0 24px;
      line-height: 60px;
    }
    .spw-text-field--is-search:not(.spw-text-field--is-clear) & {
      padding-right: 40px;
    }
    .spw-text-field--is-clear:not(.spw-text-field--is-search) & {
      padding-right: 40px;
    }
    .spw-text-field--is-clear & {
      padding-right: 70px;
    }
  }
  &__container {
    display: flex;
    align-items: center;
  }
  &__indicator {
    @apply spw-tw-pl-3;
  }
  &__icons {
    display: flex;
    align-items: center;
    position: absolute;
    top: 50%;
    right: 12px;
    gap: 8px;
    transform: translateY(-50%);
    .spw-text-field--large & {
      right: 24px;
    }
    .spw-text-field--disabled & {
      pointer-events: none;
    }
  }
  &__clear {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    cursor: pointer;
    padding: 2px;
    border: 2px var(--spw-color-themes-grey-grey-900) solid;
    border-radius: 50%;
    font-size: 12px;
    transition: all 0.2s ease-in;
    &:hover {
      background: var(--spw-color-themes-grey-grey-300);
    }
    .spw-text-field--disabled & {
      border-color: var(--spw-color-themes-grey-grey-500);
    }
  }
  &__icon {
    color: var(--spw-color-themes-grey-grey-900);
    .spw-text-field--disabled & {
      color: var(--spw-color-themes-grey-grey-500);
    }
    &--search {
      pointer-events: none;
      font-size: 18px;
      .spw-text-field--large & {
        font-size: 24px;
      }
    }
    &--clear {
      font-size: 12px;
    }
  }
}
